(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["format-selector"] && !Shopify.designMode) return;
  try {
    class FormatSelector extends HTMLElement {
      constructor() {
        super();
        this.buttons = this.querySelectorAll('.format-selector__button');
        this.init();
      }

      init() {
        this.buttons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            this.selectFormat(button);
          });
        });
      }

      selectFormat(selectedButton) {
        // Remove active class from all buttons
        this.buttons.forEach(btn => {
          btn.classList.remove('format-selector__button--active');
        });

        // Add active class to selected button
        selectedButton.classList.add('format-selector__button--active');

        // Dispatch custom event for format selection
        const format = selectedButton.dataset.format;
        this.dispatchEvent(new CustomEvent('format-selected', {
          detail: { format },
          bubbles: true
        }));
      }
    }

    customElements.define('format-selector', FormatSelector);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wine-card-purchase"] && !Shopify.designMode) return;
  try {
    (function() {
    var PRIMEURS_CART_PROPERTY_KEY = '_primeurs_scope';
    var QUANTITY_MAX_OPTIONS = 24;
    var QUANTITY_CUSTOM_VALUE = '__custom__';

    function getVariantStockMap(container) {
      try {
        return JSON.parse(container.dataset.variantStock || '{}');
      } catch (e) {
        return {};
      }
    }

    function getStockForVariant(stockMap, variantId) {
      if (!variantId) return -1;
      var raw = stockMap[String(variantId)];
      if (raw === undefined || raw === null) return -1;
      var n = parseInt(raw, 10);
      return isNaN(n) ? -1 : n;
    }

    function rebuildQuantityOptions(quantitySelect, stockForVariant) {
      if (!quantitySelect) return;

      var previousValueNum = parseInt(quantitySelect.value, 10);
      var unlimited = stockForVariant == null || stockForVariant < 0;
      var maxOptions;
      var showPlus = false;

      if (unlimited) {
        maxOptions = QUANTITY_MAX_OPTIONS;
        showPlus = true;
      } else if (stockForVariant > QUANTITY_MAX_OPTIONS) {
        maxOptions = QUANTITY_MAX_OPTIONS;
        showPlus = true;
      } else {
        maxOptions = Math.max(1, stockForVariant);
      }

      while (quantitySelect.firstChild) {
        quantitySelect.removeChild(quantitySelect.firstChild);
      }

      for (var i = 1; i <= maxOptions; i++) {
        var opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = String(i);
        quantitySelect.appendChild(opt);
      }
      if (showPlus) {
        var plusOpt = document.createElement('option');
        plusOpt.value = QUANTITY_CUSTOM_VALUE;
        plusOpt.textContent = '+';
        quantitySelect.appendChild(plusOpt);
      }

      var maxAllowed = unlimited ? Infinity : Math.max(1, stockForVariant);
      var nextValue;
      if (!isNaN(previousValueNum) && previousValueNum >= 1 && previousValueNum <= maxOptions) {
        nextValue = String(previousValueNum);
      } else if (!isNaN(previousValueNum) && previousValueNum > maxOptions && previousValueNum <= maxAllowed) {
        var customOpt = document.createElement('option');
        customOpt.value = String(previousValueNum);
        customOpt.textContent = String(previousValueNum);
        customOpt.dataset.customQuantity = 'true';
        if (showPlus) {
          quantitySelect.insertBefore(customOpt, quantitySelect.lastElementChild);
        } else {
          quantitySelect.appendChild(customOpt);
        }
        nextValue = String(previousValueNum);
      } else {
        nextValue = '1';
      }
      quantitySelect.value = nextValue;
    }

    function setCustomQuantity(quantitySelect, value) {
      if (!quantitySelect) return;
      var existingCustom = quantitySelect.querySelector('option[data-custom-quantity="true"]');
      if (existingCustom) existingCustom.remove();
      var matchingNumeric = quantitySelect.querySelector('option[value="' + String(value) + '"]');
      if (matchingNumeric) {
        quantitySelect.value = String(value);
        return;
      }
      var customOpt = document.createElement('option');
      customOpt.value = String(value);
      customOpt.textContent = String(value);
      customOpt.dataset.customQuantity = 'true';
      var plusOpt = quantitySelect.querySelector('option[value="' + QUANTITY_CUSTOM_VALUE + '"]');
      if (plusOpt) {
        quantitySelect.insertBefore(customOpt, plusOpt);
      } else {
        quantitySelect.appendChild(customOpt);
      }
      quantitySelect.value = String(value);
    }

    function showCustomQuantityDialog(stockForVariant) {
      return new Promise(function(resolve) {
        var translations = (window.Theme && window.Theme.translations) || {};
        var titleText = translations.custom_quantity_title || 'Enter quantity';
        var messageText = translations.custom_quantity_message || 'How many bottles would you like to add?';
        var applyText = translations.custom_quantity_apply || 'Apply';
        var cancelText = translations.custom_quantity_cancel || 'Cancel';
        var hintTemplate = translations.custom_quantity_max_hint || 'Maximum available: __COUNT__';
        var exceedsTemplate = translations.custom_quantity_exceeds_stock || 'Allocation limit reached';
        var hasFiniteStock = stockForVariant != null && stockForVariant >= 0;
        var hintText = hasFiniteStock
          ? hintTemplate.replace('__COUNT__', String(stockForVariant))
          : '';

        var dialog = document.createElement('dialog');
        dialog.className = 'primeurs-cart-guard-dialog wine-custom-quantity-dialog';
        dialog.style.border = '1px solid rgb(var(--color-foreground-rgb) / 0.25)';
        dialog.style.maxWidth = '24rem';
        dialog.innerHTML = '' +
          '<form method="dialog" class="primeurs-cart-guard-dialog__content">' +
            '<h3>' + titleText + '</h3>' +
            '<p>' + messageText + '</p>' +
            (hintText ? '<p style="opacity: 0.7; font-size: 0.85em; margin-top: -0.25em;">' + hintText + '</p>' : '') +
            '<input type="number" min="1" ' + (hasFiniteStock ? 'max="' + stockForVariant + '"' : '') + ' step="1" inputmode="numeric" ' +
              'data-custom-quantity-input ' +
              'style="width: 100%; padding: 8px 10px; font-size: 1rem; border: 1px solid rgb(var(--color-foreground-rgb) / 0.4); background: var(--color-background); color: var(--color-foreground); margin-top: 8px;" />' +
            '<p data-custom-quantity-error style="color: #c0392b; font-size: 0.85em; margin: 6px 0 0 0; min-height: 1.2em;"></p>' +
            '<div class="primeurs-cart-guard-dialog__actions" style="display:flex; align-items:center; gap:0.75rem; flex-wrap:nowrap; margin-top: 12px;">' +
              '<button type="button" class="button button-secondary" data-action="cancel">' + cancelText + '</button>' +
              '<button type="button" class="button button-primary" data-action="apply">' + applyText + '</button>' +
            '</div>' +
          '</form>';

        var input = dialog.querySelector('[data-custom-quantity-input]');
        var errorEl = dialog.querySelector('[data-custom-quantity-error]');
        var cancelBtn = dialog.querySelector('[data-action="cancel"]');
        var applyBtn = dialog.querySelector('[data-action="apply"]');

        function cleanup() {
          dialog.close();
          dialog.remove();
        }

        function tryApply() {
          var raw = (input && input.value || '').trim();
          var value = parseInt(raw, 10);
          if (!raw || isNaN(value) || value < 1) {
            if (errorEl) errorEl.textContent = messageText;
            return;
          }
          if (hasFiniteStock && value > stockForVariant) {
            if (errorEl) errorEl.textContent = exceedsTemplate.replace('__COUNT__', String(stockForVariant));
            return;
          }
          cleanup();
          resolve(value);
        }

        if (applyBtn) applyBtn.addEventListener('click', tryApply);
        if (cancelBtn) cancelBtn.addEventListener('click', function() { cleanup(); resolve(null); });
        dialog.addEventListener('cancel', function() { cleanup(); resolve(null); }, { once: true });
        if (input) {
          input.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
              e.preventDefault();
              tryApply();
            }
          });
        }

        document.body.appendChild(dialog);
        dialog.showModal();
        if (input) {
          input.value = hasFiniteStock ? String(Math.min(stockForVariant, QUANTITY_MAX_OPTIONS + 1)) : String(QUANTITY_MAX_OPTIONS + 1);
          input.focus();
          input.select();
        }
      });
    }

    function isPrimeursPropertyValue(value) {
      if (typeof value === 'boolean') return value;
      if (typeof value !== 'string') return false;
      var normalizedValue = value.toLowerCase();
      return normalizedValue === '1' || normalizedValue === 'true' || normalizedValue === 'yes';
    }

    function getCartComposition(cart) {
      var items = Array.isArray(cart && cart.items) ? cart.items : [];
      var hasPrimeurs = false;
      var hasRegular = false;

      items.forEach(function(item) {
        var isPrimeurs = isPrimeursPropertyValue(item && item.properties && item.properties[PRIMEURS_CART_PROPERTY_KEY]);
        if (isPrimeurs) {
          hasPrimeurs = true;
        } else {
          hasRegular = true;
        }
      });

      return { hasPrimeurs: hasPrimeurs, hasRegular: hasRegular };
    }

    function fetchAjaxCart() {
      return fetch('/cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' }
      })
        .then(function(response) {
          if (!response.ok) return null;
          return response.json();
        })
        .catch(function(error) {
          console.error('Could not fetch cart state:', error);
          return null;
        });
    }

    function clearAjaxCart() {
      return fetch('/cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json' }
      });
    }

    function showClearCartModal() {
      return new Promise(function(resolve) {
        var dialog = document.createElement('dialog');
        dialog.className = 'primeurs-cart-guard-dialog';
        dialog.style.border = '1px solid rgb(var(--color-foreground-rgb) / 0.25)';
        dialog.style.maxWidth = '30rem';
        var title = (window.Theme && Theme.translations && Theme.translations.primeurs_guard_title) || 'En Primeur';
        var message =
          (window.Theme && Theme.translations && Theme.translations.primeurs_guard_message) ||
          'En Primeur orders are processed separately from in-stock wines and cannot be combined in the same cart.\n\nClear your cart to continue, or save this wine to your wishlist for later.';
        var cancelLabel = (window.Theme && Theme.translations && Theme.translations.primeurs_guard_cancel) || 'Cancel';
        var clearLabel = (window.Theme && Theme.translations && Theme.translations.primeurs_guard_clear) || 'Clear cart';
        dialog.innerHTML = '' +
          '<form method="dialog" class="primeurs-cart-guard-dialog__content">' +
          '<h3>' + title + '</h3>' +
          '<p style="white-space: pre-line">' + message + '</p>' +
          '<div class="primeurs-cart-guard-dialog__actions" style="display:flex; align-items:center; gap:0.75rem; flex-wrap:nowrap;">' +
          '<button type="button" class="button button-secondary" data-action="cancel">' + cancelLabel + '</button>' +
          '<button type="button" class="button button-primary" data-action="clear">' + clearLabel + '</button>' +
          '</div>' +
          '</form>';

        function cleanup() {
          dialog.close();
          dialog.remove();
        }

        var clearBtn = dialog.querySelector('[data-action="clear"]');
        var cancelBtn = dialog.querySelector('[data-action="cancel"]');

        if (clearBtn) {
          clearBtn.addEventListener('click', function() {
            cleanup();
            resolve(true);
          });
        }

        if (cancelBtn) {
          cancelBtn.addEventListener('click', function() {
            cleanup();
            resolve(false);
          });
        }

        dialog.addEventListener('cancel', function() {
          cleanup();
          resolve(false);
        }, { once: true });

        document.body.appendChild(dialog);
        dialog.showModal();
      });
    }

    function openCartDrawer() {
      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    }

    // Initialize each container individually with its own event handlers
    function initializeContainer(container) {
      // Skip if already initialized
      if (container.dataset.winePurchaseInitialized === 'true') return;
      container.dataset.winePurchaseInitialized = 'true';
      
      // Get elements directly from this container - store references
      const purchaseButton = container.querySelector('[data-purchase-button]');
      const purchaseOptions = container.querySelector('[data-purchase-options]');
      const closeButton = container.querySelector('[data-close-options]');
      const addToCartButton = container.querySelector('[data-add-to-cart]');
      const variantSelect = container.querySelector('.wine-variant-select');
      const quantitySelect = container.querySelector('.wine-quantity-select');
      
      if (!purchaseButton || !purchaseOptions || !closeButton) return;
      
      // Store direct references in closure - these are the ONLY elements we'll modify
      const thisPurchaseOptions = purchaseOptions;
      const thisCloseButton = closeButton;
      const thisPurchaseButton = purchaseButton;
      const thisAddButton = addToCartButton;
      const purchaseButtonDefaultText = (thisPurchaseButton.textContent || '').trim();
      const purchaseButtonAddedText = container.dataset.addedText || 'Added';
      const variantStockMap = getVariantStockMap(container);

      function currentVariantStock() {
        const variantId = variantSelect ? variantSelect.value : container.dataset.firstVariantId;
        return getStockForVariant(variantStockMap, variantId);
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', function() {
          rebuildQuantityOptions(quantitySelect, currentVariantStock());
        });
      }

      if (quantitySelect) {
        let lastValidQuantityValue = quantitySelect.value || '1';
        quantitySelect.addEventListener('change', function() {
          if (quantitySelect.value !== QUANTITY_CUSTOM_VALUE) {
            lastValidQuantityValue = quantitySelect.value;
            return;
          }
          const stockForVariant = currentVariantStock();
          showCustomQuantityDialog(stockForVariant).then(function(value) {
            if (value == null) {
              quantitySelect.value = lastValidQuantityValue;
              return;
            }
            setCustomQuantity(quantitySelect, value);
            lastValidQuantityValue = quantitySelect.value;
          });
        });
      }

      function expandPurchaseOptions() {
        thisPurchaseOptions.style.maxHeight = '500px';
        thisPurchaseOptions.style.opacity = '1';
        thisPurchaseOptions.style.marginBottom = '12px';
        thisPurchaseOptions.style.pointerEvents = 'auto';
        thisCloseButton.style.maxHeight = '50px';
        thisCloseButton.style.opacity = '1';
        thisCloseButton.style.marginTop = '8px';
        thisCloseButton.style.padding = '8px 16px';
        thisCloseButton.style.pointerEvents = 'auto';
        thisPurchaseButton.style.display = 'none';
        if (thisAddButton) thisAddButton.style.display = '';
      }

      function collapsePurchaseOptions() {
        thisPurchaseOptions.style.maxHeight = '0';
        thisPurchaseOptions.style.opacity = '0';
        thisPurchaseOptions.style.marginBottom = '0';
        thisPurchaseOptions.style.pointerEvents = 'none';
        thisCloseButton.style.maxHeight = '0';
        thisCloseButton.style.opacity = '0';
        thisCloseButton.style.marginTop = '0';
        thisCloseButton.style.padding = '0';
        thisCloseButton.style.pointerEvents = 'none';
        thisPurchaseButton.style.display = '';
        if (thisAddButton) thisAddButton.style.display = 'none';
      }

      function showAddedState() {
        thisPurchaseButton.classList.add('is-added');
        thisPurchaseButton.textContent = purchaseButtonAddedText;
        thisPurchaseButton.disabled = true;
        setTimeout(function() {
          thisPurchaseButton.classList.remove('is-added');
          thisPurchaseButton.textContent = purchaseButtonDefaultText;
          thisPurchaseButton.disabled = false;
        }, 1500);
      }
      
      // Purchase button handler - only modifies THIS container's elements
      purchaseButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (purchaseButton.disabled) return;
        expandPurchaseOptions();
      });
      
      // Close button handler - only modifies THIS container's elements
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        collapsePurchaseOptions();
      });
      
      // Add to cart button handler
      if (addToCartButton) {
        addToCartButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const productId = container.dataset.productId;
          const variantId = variantSelect ? variantSelect.value : container.dataset.firstVariantId;
          let quantity = 1;
          if (quantitySelect) {
            const parsedQty = parseInt(quantitySelect.value, 10);
            quantity = isNaN(parsedQty) || parsedQty < 1 ? 1 : parsedQty;
          }
          
          if (!variantId) return;
          if (variantSelect && variantSelect.options[variantSelect.selectedIndex]?.disabled) return;
          
          addToCartButton.disabled = true;
          
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', quantity);
          const isPrimeursProduct = container.dataset.isPrimeursProduct === 'true';
          if (isPrimeursProduct) {
            formData.append('properties[' + PRIMEURS_CART_PROPERTY_KEY + ']', '1');
          }
          
          const cartItemsComponents = document.querySelectorAll('cart-items-component');
          const sectionIds = [];
          cartItemsComponents.forEach(function(item) {
            if (item instanceof HTMLElement && item.dataset.sectionId) {
              sectionIds.push(item.dataset.sectionId);
            }
          });
          if (sectionIds.length) formData.append('sections', sectionIds.join(','));
          
          const headers = { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' };
          
          const cartAddUrl = (typeof Theme !== 'undefined' && Theme.routes) ? Theme.routes.cart_add_url : '/cart/add.js';
          fetchAjaxCart()
            .then(function(cart) {
              var composition = getCartComposition(cart);
              var hasConflict = (isPrimeursProduct && composition.hasRegular) || (!isPrimeursProduct && composition.hasPrimeurs);
              if (!hasConflict) return true;

              return showClearCartModal().then(function(shouldClear) {
                if (!shouldClear) return false;
                return clearAjaxCart()
                  .then(function() { return true; })
                  .catch(function(error) {
                    console.error('Could not clear cart:', error);
                    return false;
                  });
              });
            })
            .then(function(canProceed) {
              if (!canProceed) return null;
              return fetch(cartAddUrl, {
                method: 'POST',
                headers: headers,
                body: formData
              });
            })
            .then(function(res) {
              if (!res) return null;
              return res.json();
            })
            .then(function(response) {
              if (!response) return;
              if (response.status) {
                alert(response.message || 'Unable to add to cart');
              } else {
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: {},
                    sourceId: container.dataset.containerId || '',
                    data: {
                      source: 'wine-card-purchase',
                      itemCount: quantity,
                      productId: productId,
                      variantId: variantId.toString(),
                      sections: response.sections
                    }
                  }
                }));
                openCartDrawer();
                collapsePurchaseOptions();
                showAddedState();
              }
            })
            .catch(function(err) {
              console.error('Add to cart error:', err);
              alert('Unable to add to cart');
            })
            .finally(function() {
              addToCartButton.disabled = false;
            });
        });
      }
    }
    
    // Initialize all containers
    function initAllContainers() {
      const containers = document.querySelectorAll('.wine-purchase-container:not([data-wine-purchase-initialized="true"])');
      containers.forEach(initializeContainer);
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllContainers);
    } else {
      initAllContainers();
    }
    
    // Re-initialize for dynamically added content
    document.addEventListener('shopify:section:load', initAllContainers);
    
    // Also use MutationObserver for any other dynamic additions
    const observer = new MutationObserver(function(mutations) {
      initAllContainers();
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
